import member from '@/page/member/index.vue'
import memberHistory from '@/page/member/components/history/index.vue'
import cancelTake from '@/page/member/components/cancelTake/index.vue'
import subscribeLoading from '@/page/member/components/subscribeLoading/index.vue'
import joinSubscription from '@/page/member/components/joinSubscription/index.vue'
import oldMember from "@/page/member/components/oldMember/index.vue";

const memberPage =  {
  path: '/member',
  name: 'member',
  component: member
}

const memberHistoryPage = {
  path: '/memberHistory',
  name: 'memberHistory',
  component: memberHistory
}

const cancelTakePage = {
  path: '/cancelTake',
  name: 'cancelTake',
  component: cancelTake
}

const subscribeLoadingPage = {
  path: '/subscribeLoading',
  name: 'subscribeLoading',
  component: subscribeLoading
}

const joinSubscriptionPage = {
  path: '/joinSubscription',
  name: 'joinSubscription',
  component: joinSubscription
}

const oldMemberPage = {
  path: "/oldMember",
  name: "oldMember",
  component: oldMember,
};

export default [
  memberPage,
  memberHistoryPage,
  cancelTakePage,
  subscribeLoadingPage,
  joinSubscriptionPage,
  oldMemberPage,
];